import React, {useState, useRef, useEffect} from "react";
import {Button} from 'primereact/button';
import {Toast} from "primereact/toast";
import {InputText} from "primereact/inputtext";
import '../../css/DataTableDemo.css'
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Card} from "primereact/card";
import {Dialog} from "primereact/dialog";
import {Link} from "react-router-dom";
import {Fieldset} from "primereact/fieldset";
import axios from "axios";

const ModuleSubScriptionCancellation = props => {
    const result = props.match.params['result'];

    useEffect(() => {
        getContentListTrash();


    }, []);
    const toast = useRef(null);
    const [cipDeleteDialog, setCipDeleteDialog] = useState(false);
    const [email, setEmail] = useState('');

    const body = {
        display: "flex",
        alignItems: "center",
        minHeight: "25vh"
    };

    const content = {
        textAlign: "center",
        justifyContent: "center",
    };

    const a = {
        marginTop: "40px",
        width: "250px",
        textAlign: "center",
        alignItems: "center",
        padding: "0.5rem 1rem",
        color: "#ffffff",
        backgroundColor: "rgb(66,142,255)",
        borderRadius: "7px"
    };

    const title = {
        fontSize: "80px",
        fontWeight: "700",
    };


    useEffect(() => {


    }, []); //Buradaki dizi içine yazılan değer, değişince useeffecti çalıştır.

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }
    const getContentListTrash = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/mail-delete/', {"headers": headers})
            .then(res => {
                setEmail(res.data.registered_mail)
            })
    }


    const renderFooter = () => {
        return (
            <div>

                <Button label="Hayır" icon="pi pi-times" onClick={() => setCipDeleteDialog(false)}
                        className="p-button-text"/>
                <Button label="Evet" icon="pi pi-check" onClick={() => submit()} autoFocus/>
            </div>
        );
    }


    const submit = () => {
        setCipDeleteDialog(false)
        let re = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i;
        if (re.test(email)) {
            var obj = {
                email: email

            };
            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");
            if (token) {
                headers["Authorization"] = `Token ${token}`;
                const body = JSON.stringify(obj);
                fetch("/api/mail-delete/", {headers, method: "POST", body})
                    .then(res => {
                        if (res.status < 500) {

                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {

                            const data = res.data;
                            if (data.result) {
                                showSuccess(data.message);
                            } else {
                                showError(data.message);
                            }
                        } else if (res.status === 401) {
                            props.loadUser();
                            throw res.data;

                        } else if (res.status === 403) {
                            throw res.data;

                        }
                    })

            }

            setEmail('')


        } else {
            showError("Geçersiz e-posta adresi. Örneğin. örnek@email.com");
        }
    }

    if (result === "true") {
        return (
            <div style={body}>
                <Card title="e-Bülten Abonelik İptali" style={{width: '50rem', marginBottom: '2em'}}>
                    <div align="center" style={{'fontSize': '20px'}}>
                        <i className="pi pi-check-circle"
                           style={{'fontSize': '50px', color: 'green', marginTop: '50px'}}>
                        </i>
                        <p style={{color: 'green', marginTop: '20px'}}> e-Bülten aboneliğiniz iptal edilmiştir.</p>
                    </div>
                </Card>

            </div>

        )

    } else if (result === "false") {

        return (
            <div style={body}>
                <div className="p-grid" style={content}>
                    <div className="p-col-12 p-col-sm-12 p-col-md-12 p-col-lg-12" style={title}>
                        e-Bülten aboneliğini iptal etme yetkiniz yoktur.
                    </div>
                    <Link style={a} to="/">Ana Sayfaya Dön</Link>
                </div>
            </div>

        )


    } else {
        return (
            <div className="p-fluid" style={{fontSize: 'large'}}>
                <Dialog header="UYARI" visible={cipDeleteDialog}
                        style={{width: '20%'}}
                        footer={renderFooter()}

                        onHide={() => setCipDeleteDialog(false)}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{fontSize: '2rem'}}/>
                        <span>İptal İşlemi Gerçekleştirmek İstediğinizden Emin Misiniz?</span>
                    </div>


                </Dialog>

                <Toast ref={toast}/>
                <div className="p-col-12 p-md-12">


                    <Fieldset legend="e-Bülten Kayıt İptali">
                        <div className="p-col-12 p-md-8" style={{marginTop: '30px', marginLeft: '50px'}}>
                            <h5>1.İptal işlemi için kayıtlı e-mail adresinizi giriniz.
                                <hr></hr>
                                2. Mail adresinize gelen üyelik iptali linkine tıklayarak üyeliğinizi
                                sonlandırabilirsiniz.
                            </h5>
                            <hr></hr>

                            <div className="p-inputgroup p-md-6">
                                <InputText type="text" className="p-d-block"
                                           placeholder="E-Mail" value={email}
                                           onChange={(e) => setEmail(e.target.value)}
                                />
                                <Button icon="pi pi-times" className="p-button-warning"
                                        label="Abonelikten Çık"
                                        onClick={() => setCipDeleteDialog(true)}/>
                            </div>
                        </div>

                    </Fieldset>
                </div>


            </div>


        )
    }


}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ModuleSubScriptionCancellation);


// WEBPACK FOOTER //
// ./src/pages/modulemanagement/ModuleSubScriptionCancellation.jsx